const NoraMenuItems = [{id:'/Installations',key:'categoryLabel:CAT_GRP_INSTALLATIONS'}
                      ,{id:'/Pictures',key:'categoryLabel:CAT_GRP_PICTURES'}
                      ,{id:'/Objects',key:'categoryLabel:CAT_GRP_OBJECTS'}
                      ,{id:'/NewsItems',key:'common:LABEL_CURRENT'}
                      ,{id:'/Biography',key:'common:LABEL_BIOGRAPHY'}
                      ,{id:'/Links',key:'common:LABEL_LINKS'}
                      ,{id:'/Contact',key:'common:LABEL_CONTACT'}
                      ];
export default NoraMenuItems;